/**
 * Screen sharing with the support, client side (/api/partage-ecran/): the
 * presence signal, answering a request, offering a share from the support
 * widget, stopping it. The page itself and the arrow go through the
 * WebSocket (components/screenShare/session.ts), never through these calls.
 */
import { api } from '@/lib/api'
import { API_BASE_URL } from '@/lib/config'

export type ShareEnd = 'client' | 'support' | 'duree' | 'deconnexion' | ''

export interface PendingRequest {
  id: number
  /** The support member's first name. */
  support: string
  expire_dans: number
}

export interface ShareInfo {
  id: number
  statut: 'demande' | 'en_attente' | 'en_cours' | 'refuse' | 'termine' | 'expire'
  expire_dans?: number
}

export const screenShareApi = {
  presence: (page: string) =>
    api.post<{ demande: PendingRequest | null }>('/api/partage-ecran/presence/', { page }).then((r) => r.data),
  accept: (id: number) => api.post<ShareInfo>(`/api/partage-ecran/${id}/accepter/`, {}).then((r) => r.data),
  refuse: (id: number) => api.post<ShareInfo>(`/api/partage-ecran/${id}/refuser/`, {}).then((r) => r.data),
  offer: (conversation?: string) =>
    api.post<ShareInfo & { code: string }>('/api/partage-ecran/', { conversation: conversation ?? '' }).then((r) => r.data),
  stop: (id: number) => api.post<ShareInfo>(`/api/partage-ecran/${id}/terminer/`, {}).then((r) => r.data),
}

/** The WebSocket address of a share, on the API host. */
export function shareSocketUrl(id: number): string {
  const base = String(import.meta.env.VITE_WS_BASE_URL || API_BASE_URL).replace(/^http/, 'ws').replace(/\/+$/, '')
  return `${base}/ws/partage-ecran/${id}/`
}
